import BlotFormatter from "quill-blot-formatter/dist/BlotFormatter";

class _BlotFormatter extends BlotFormatter {
    constructor(quill) {
        super(quill);
        Object.assign(this.overlay.style || {}, {
            zIndex: 10,
        });
        const resizeObserver = new ResizeObserver(() => this.update.call(this));
        resizeObserver.observe(quill.root);
    }
}

export default _BlotFormatter;
